import {SpeedTypes} from '../enums';
import {wordByCount} from '../utils';

type Speed = {
	type: 'walk' | 'burrow' | 'fly' | 'swim';
	value: number;
	hover?: boolean;
	note?: string;
};

export function toMonsterSpeed(speed: Speed[]) {
	return speed
		.map((i) => {
			let result = i.type === 'walk' ? '' : SpeedTypes[i.type];
			result += ' ' + wordByCount(i.value, ['фут', 'фута', 'футов'], true);

			const breckets = [];
			if (i.hover) breckets.push('парение');
			if (i.note) breckets.push(i.note);

			if (breckets.length) result += ` (${breckets.join('; ')})`;

			return result;
		})
		.join(', ');
}
